import React from "react";

interface IProps {
  className: string;
}
const Lamp = function ({ className }: IProps): JSX.Element {
  return (
    <svg
      width="83"
      height="83"
      viewBox="0 0 83 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M68.6703 36.2578C68.6703 51.3087 56.4684 63.5106 41.4175 63.5106C26.3667 63.5106 14.1648 51.3087 14.1648 36.2578C14.1648 21.207 26.3667 9.00504 41.4175 9.00504C56.4684 9.00504 68.6703 21.207 68.6703 36.2578Z"
        fill="#FCCB74"
      />
      <path
        d="M37.0535 49.3372H45.7743C50.9076 49.3372 55.0402 53.4698 55.0402 58.6031V67.3239C55.0402 72.4571 50.9076 76.5897 45.7743 76.5897H37.0535C31.9202 76.5897 27.7876 72.4571 27.7876 67.3239V58.6031C27.7876 53.4698 31.9202 49.3372 37.0535 49.3372Z"
        fill="#FCCB74"
      />
      <path
        d="M34.8472 65.9954L48.3823 63.5046C48.8278 63.4226 49.2524 63.7152 49.3343 64.1607C49.4163 64.6061 49.1237 65.0308 48.6782 65.1127L35.1432 67.6035C34.6977 67.6855 34.2731 67.3928 34.1911 66.9474C34.1091 66.5019 34.4018 66.0773 34.8472 65.9954Z"
        fill="white"
      />
      <path
        d="M34.84 70.3089L48.3751 67.8182C48.8205 67.7362 49.2452 68.0287 49.3271 68.4742C49.4091 68.9197 49.1165 69.3443 48.671 69.4263L35.1359 71.917C34.6905 71.999 34.2659 71.7063 34.1839 71.2609C34.1019 70.8154 34.3945 70.3909 34.84 70.3089Z"
        fill="white"
      />
      <path
        d="M28.3452 44.2293C26.2696 44.2293 24.4879 43.5041 23 42.0537C21.5121 40.5908 20.7681 38.8215 20.7681 36.7459C20.7681 34.6703 21.512 32.901 23 31.4382C24.4879 29.9627 26.2697 29.2251 28.3452 29.2251H32.7903C32.7903 30.0503 32.4964 30.7567 31.9088 31.3443C31.3211 31.9195 30.6147 32.2071 29.7895 32.2071H28.3453C27.12 32.2071 26.0759 32.6572 25.2132 33.5574C24.3504 34.4577 23.919 35.5205 23.919 36.7459C23.919 37.9712 24.3504 39.0278 25.2132 39.9156C26.0759 40.8034 27.1199 41.2472 28.3453 41.2472H29.7895C30.6147 41.2472 31.3212 41.541 31.9088 42.1287C32.4964 42.7039 32.7903 43.4041 32.7903 44.2293H28.3452V44.2293ZM27.2949 35.2455H32.7903C32.7902 36.0707 32.4964 36.7709 31.9088 37.3461C31.3211 37.9212 30.6146 38.2088 29.7894 38.2088H27.2949C26.8823 38.2088 26.5322 38.0713 26.2446 37.7962C25.9571 37.5086 25.8133 37.1585 25.8133 36.7459C25.8133 36.3207 25.9508 35.9644 26.2259 35.6769C26.5135 35.3893 26.8698 35.2455 27.2949 35.2455Z"
        fill="white"
      />
      <path
        d="M41.3525 44.2293C39.2769 44.2293 37.4952 43.5041 36.0073 42.0537C34.5194 40.5908 33.7753 38.8215 33.7753 36.7459C33.7753 34.6703 34.5193 32.901 36.0073 31.4382C37.4952 29.9627 39.277 29.2251 41.3525 29.2251H45.7788C45.7788 30.0503 45.485 30.7567 44.8973 31.3443C44.3221 31.9195 43.6219 32.2071 42.7968 32.2071H41.3526C40.1148 32.2071 39.0582 32.6572 38.1829 33.5574C37.3202 34.4452 36.8888 35.508 36.8888 36.7459C36.8888 37.9838 37.3202 39.0465 38.1829 39.9343C39.0582 40.8096 40.1148 41.2472 41.3526 41.2472H42.7968C43.622 41.2472 44.3222 41.541 44.8973 42.1287C45.485 42.7039 45.7788 43.4041 45.7788 44.2293H41.3525"
        fill="white"
      />
      <path
        d="M53.987 29.2299C56.0626 29.2299 57.8443 29.9676 59.3322 31.4431C60.8325 32.9061 61.5828 34.6753 61.5828 36.7508C61.5828 38.8264 60.8326 40.5957 59.3322 42.0586C57.8443 43.509 56.0625 44.2342 53.987 44.2342C51.9113 44.2342 50.1296 43.509 48.6417 42.0586C47.1538 40.5957 46.4098 38.8264 46.4098 36.7508C46.4098 34.6752 47.1538 32.906 48.6417 31.4431C50.1296 29.9676 51.9114 29.2299 53.987 29.2299ZM53.987 32.212C52.7491 32.212 51.6988 32.6621 50.836 33.5624C49.9857 34.4501 49.5606 35.5129 49.5606 36.7508C49.5606 37.9887 49.9857 39.0515 50.836 39.9393C51.6987 40.8145 52.7491 41.2521 53.987 41.2521C55.2248 41.2521 56.2751 40.8145 57.1379 39.9393C58.0006 39.0515 58.432 37.9887 58.432 36.7508C58.432 35.5129 58.0006 34.4502 57.1379 33.5624C56.2751 32.6621 55.2248 32.212 53.987 32.212Z"
        fill="white"
      />
    </svg>
  );
};

export default Lamp;
